export const Prices=[
    {
        _id:1,
        name:"0 to 200 rupees",
        array:[0,200]
    },
    {
        _id:2,
        name:"200 to 400 rupees",
        array:[200,400]
    },
    {
        _id:3,
        name:"400 to 600 rupees",
        array:[400,600]
    },
    {
        _id:4,
        name:"600 to 900 rupees",
        array:[600,900]
    },
    {
        _id:5,
        name:"900 to 2000 rupees",
        array:[900,2000]
    },
    {
        _id:6,
        name:"above 2000 ",
        array:[2000,200000]
    },
]